/**
 * Keeps Shopify's express checkout buttons (PayPal, Shop Pay, ...) out of the DOM until
 * the visitor gave marketing consent in the cookie banner. Without this, Shopify's
 * portable wallets load the PayPal SDK on page load (BAS-5865).
 */
class PaypalConsent extends HTMLElement {
    connectedCallback() {
        if (window.Shopify?.customerPrivacy?.marketingAllowed?.()) {
            this.reveal();
            return;
        }

        window.Shopify?.loadFeatures([
            {
                name: 'consent-tracking-api',
                version: '0.1',
                onLoad: errors => {
                    if (errors) {
                        console.error(errors);
                        return;
                    }

                    if (window.Shopify?.customerPrivacy?.marketingAllowed()) {
                        this.reveal();
                    }
                },
            },
        ]);

        document.addEventListener('visitorConsentCollected', event => {
            if (event.detail.marketingAllowed) {
                this.reveal();
            }
        });
    }

    reveal() {
        const template = this.querySelector('template');

        if (!template) {
            return;
        }

        this.appendChild(template.content.cloneNode(true));
        template.remove();
    }
}

if (!customElements.get('paypal-consent')) {
    customElements.define('paypal-consent', PaypalConsent);
}
